/* src/app/shared/components/new-drawer/search/components/employees-search/employees-search-form.component.scss */
:host {
  display: flex;
  flex: 1;
}
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
}
.container__form {
  flex: 1;
}
.container__buttons-wrapper {
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 1rem;
}
/*# sourceMappingURL=employees-search-form.component.css.map */
